module.exports = __webpack_public_path__ + "static/media/page3_furba4.aa24474b.wav";